import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import '../../css/NotificationsPanel.css';

const NotificationsPanel = ({ onClose }) => {
  const { notifications, markAsRead, markAllAsRead } = useNotifications();

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'new_application':
        return <i className="fas fa-file-alt notification-icon"></i>;
      case 'interview_scheduled':
        return <i className="fas fa-calendar-alt notification-icon"></i>;
      case 'interview_accepted':
        return <i className="fas fa-handshake notification-icon success"></i>;
      case 'application_accepted':
        return <i className="fas fa-check-circle notification-icon success"></i>;
      case 'application_rejected':
        return <i className="fas fa-times-circle notification-icon danger"></i>;
      case 'status_update':
        return <i className="fas fa-info-circle notification-icon"></i>;
      default:
        return <i className="fas fa-bell notification-icon"></i>;
    }
  };

  const getNotificationClass = (type) => {
    switch (type) {
      case 'application_accepted':
        return 'success-notification';
      case 'application_rejected':
        return 'danger-notification';
      case 'interview_scheduled':
      case 'interview_accepted':
        return 'info-notification';
      default:
        return '';
    }
  };

  // Modified to only mark as read without navigation
  const handleNotificationClick = async (notification) => {
    if (!notification.read) {
      markAsRead(notification._id);
    }
  };

  return (
    <div className="notifications-panel">
      <div className="notifications-header">
        <h3>Notifications</h3>
        {notifications.some(n => !n.read) && (
          <button 
            type="button"
            className="mark-all-read-btn"
            onClick={markAllAsRead}
          >
            Mark all as read
          </button>
        )}
      </div>
      <div className="notifications-list">
        {notifications.length === 0 ? (
          <div className="no-notifications">
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification._id || Math.random().toString()}
              className={`notification-item ${notification.read ? 'read' : 'unread'} ${getNotificationClass(notification.type)}`}
              onClick={() => handleNotificationClick(notification)}
            >
              <div className="notification-icon-container">
                {getNotificationIcon(notification.type)}
              </div>
              <div className="notification-content">
                <p className="notification-message">{notification.message}</p>
                <span className="notification-time">
                  {formatDate(notification.createdAt)}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationsPanel; 